import React, { useState, useMemo } from "react";
import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Stack,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { Header } from "../common/header";
import { Sidebar } from "../common/sidebar";
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Entities } from "./entities";
import { EmployeeManagement } from "./employee-management";
import {
  getUsers,
  getEntities,
  getRoles,
  getMyState,
} from "../../state/user/actions";
import { LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Attendance } from "./attendance";
import { Leaves } from "./leaves";
import { LeaveActions } from "./leave-actions";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import axios from "axios";
import { ApplyLeave } from "./apply-leave";
import { AdminEntities } from "./admin-entities";
import { Allocation } from "./allocation";
import { ResourceManagement } from "./resource-management";
import { Caller } from "./caller";
import { EmployeeProfile } from "./employee-management/details";
import { EmployeeDebug } from "./employee-management/employeedebug";
import { ActiveDebug } from "./allocation/master-database/active-debug";
import { ConnectedDebug } from "./allocation/reports/ecd-debug";
import { Campaigns as CampaignsComponent } from "./campaigns";
import { Sankalp } from "./allocation/sankalp";
import { CONFIG } from "../../config/index";
import { ViewShifts } from "./allocation/view-shifts";
import { HomeDashboard } from "./home/index";
import QA from "./QA";
import { styled, useTheme } from "@mui/material/styles";
import { MasterData } from "./allocation/master-data";
import { MasterDatabase } from "./allocation/master-database";
import { Allocations } from "./allocation/allocations";
import { Reports } from "./allocation/reports";
import { Uploads } from "./allocation/upload/index";
import QualityAssurance from "./allocation/reports/quality-assurance";
import TelecallerIndividual from "./allocation/reports/telecaller-individual";
import TeamleadView from "./allocation/reports/teamlead-view";
import { Logs } from "./logs";

import { Toaster } from "react-hot-toast";
import { Analytics } from "../dashboard/allocation/analytics";
import CaseDetailsMotherId from "./case-details/case-details-motherid";
import { CallsIndex } from "./allocation/calls/calls.index";

const drawerWidth = 280;

const ACCOUNT_HOST = CONFIG.modules["accounts"].host;
const CRM_HOST = CONFIG.modules["crm"].host;

const { Manager } = require("socket.io-client");

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    // The main panel has extra width because the sidebar is open
    // need to chang ehte width depending on whether the sidebar is open or not
    ...(open && {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: 0,
    }),

    // change the maxwidth of main to be the vw
    ...(!open && {
      maxWidth: "100vw",
      // marginLeft: 0,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

export const Dashboard = (props) => {
  const [sock, setSock] = useState(null);

  let pingInterval;
  let socket;
  let socketCrm;
  const { user, requestingCheckAuth } = useSelector(
    (state) => state.user || {}
  );

  const {
    Designations,
    Departments,
    Languages,
    Districts,
    Priviledges,
    Shifts,
    TaskTypes,
    Campaigns,
    Hierarchies,
    FieldTypes,
    Validations,
    CampaignForms,
    LeaveType,
    Query,
    SubQuery,
    UnassignReasons,
  } = useSelector((state) => state.user || {});

  const previousRequestingCheckAuth = useRef(requestingCheckAuth);
  const previousUser = useRef(null);
  const dispatch = useDispatch();
  const [openS, setOpenS] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpenS(true);
  };

  const handleDrawerClose = () => {
    setOpenS(false);
  };

  // Check if all essential Redux states are loaded
  const isReduxLoaded = useMemo(() => {
    return !!(
      Designations &&
      Departments &&
      Languages &&
      Districts &&
      Priviledges &&
      Shifts &&
      TaskTypes &&
      Campaigns &&
      Hierarchies &&
      FieldTypes &&
      Validations &&
      CampaignForms &&
      LeaveType &&
      Query &&
      SubQuery &&
      UnassignReasons
    );
  }, [
    Designations,
    Departments,
    Languages,
    Districts,
    Priviledges,
    Shifts,
    TaskTypes,
    Campaigns,
    Hierarchies,
    FieldTypes,
    Validations,
    CampaignForms,
    LeaveType,
    Query,
    SubQuery,
    UnassignReasons,
  ]);

  useEffect(() => {
    if (isReduxLoaded) {
      console.log("Districts", Districts);
    }
  }, [isReduxLoaded]);

  useEffect(() => {
    return () => {
      if (pingInterval) clearInterval(pingInterval);
      if (socket) {
        socket.removeAllListeners();
      }
    };
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      props.history.push("/login");
    }
    dispatch(getUsers());
    dispatch(getRoles());
    dispatch(getEntities("Designations"));
    dispatch(getEntities("Departments"));
    dispatch(getEntities("Languages"));
    dispatch(getEntities("Districts"));
    dispatch(getEntities("Priviledges"));
    dispatch(getEntities("Shifts"));
    dispatch(getEntities("TaskTypes"));
    dispatch(getEntities("Campaigns"));
    dispatch(getEntities("Hierarchies"));
    dispatch(getEntities("FieldTypes"));
    dispatch(getEntities("Validations"));
    dispatch(getEntities("CampaignForms"));
    dispatch(getEntities("LeaveType"));
    dispatch(getEntities("Query"));
    dispatch(getEntities("SubQuery"));
    dispatch(getEntities("UnassignReasons"));
  }, []);

  useEffect(() => {
    if (user) {
      const manager = new Manager(CONFIG.modules["accounts"].socket, {
        reconnectionDelayMax: 10000,
        path: "/accounts",
      });

      const crmManager = new Manager(CONFIG.modules["crm"].socket, {
        reconnectionDelayMax: 10000,
        path: "/crm",
      });
      document.title = `Aveneues CRM - ${user.name}`;

      socket = manager.socket("/common", {
        query: {
          token: localStorage.getItem("authToken") || "",
        },
      });
      socketCrm = crmManager.socket("/common", {
        query: {
          token: localStorage.getItem("authToken") || "",
        },
      });
      setSock(socketCrm);
      pingInterval = setInterval(() => {
        socket.emit("user-state", "online");
      }, 5000);

      dispatch(getMyState());
    }
    if (!user && previousUser.current) {
      props.history.push("/login");
    }
    previousUser.current = user;
  }, [user]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (user) {
        const data = {
          userId: user?._id,
          action: "page_close",
          timestamp: new Date().toISOString(),
        };
        const jsonString = JSON.stringify(data);
        navigator.sendBeacon(ACCOUNT_HOST + "/beacon", jsonString);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [user]);

  useEffect(() => {
    // console.log(requestingCheckAuth ,previousRequestingCheckAuth.current)
    // if(!user && !requestingCheckAuth && previousRequestingCheckAuth.current==true) {
    //     props.history.push('/login')
    // }
    // previousRequestingCheckAuth.current = requestingCheckAuth
  }, [requestingCheckAuth]);

  return (
    <>
      {!isReduxLoaded && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {isReduxLoaded && (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{ width: "100vw", height: "100vh" }}>
            <Toaster position="top-right" reverseOrder={false} />
            <Header
              handleDrawerOpen={handleDrawerOpen}
              openS={openS}
              handleDrawerClose={handleDrawerClose}
            ></Header>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                // NOTE: change dated 29/07/2025
                // Trying to make it occupy the full height
                height: "100%",
              }}
            >
              <Sidebar
                handleDrawerOpen={handleDrawerOpen}
                openS={openS}
                handleDrawerClose={handleDrawerClose}
              ></Sidebar>
              <Main open={openS}>
                <Box
                  sx={{
                    // mt: "4em",
                    //  padding: "10px",
                    paddingTop: "4em",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  {/* This Below stack component was causing that little tiny width increase */}
                  {/* Keeping it as comment because this codebase is filled with comments like this */}
                  {/* <Stack py={1}></Stack> */}
                  <Stack
                    direction={"column"}
                    px={2}
                    pt={0.5}
                    // NOTE : change dated 29/07/2025
                    // Trying to make it occupy the full height
                    height={"100%"}
                  >
                    <Switch>
                      <Route path={"/hr/entities"} component={Entities} />
                      <Route path={"/admin/assets"} component={AdminEntities} />
                      <Route
                        path={"/hr/employee-management/detail"}
                        component={EmployeeProfile}
                      />
                      <Route
                        path={"/hr/employee-management"}
                        component={EmployeeManagement}
                      />
                      <Route
                        path={"/hr/employee-management-debug"}
                        component={EmployeeDebug}
                      />

                      <Route path={"/lead/sankalp"} component={Sankalp} />
                      <Route
                        path={"/lead/view-shifts"}
                        component={ViewShifts}
                      />
                      <Route
                        path={"/lead/call-data/reports/QualityAssurance"}
                        component={QualityAssurance}
                      />
                      {/* Route for individual telecaller details */}
                      <Route
                        path={"/lead/telecallers"}
                        component={TelecallerIndividual}
                      />
                      {/* Route for teamlead insights */}
                      <Route path={"/lead/insights"} component={TeamleadView} />
                      <Route path={"/hr/attendance"} component={Attendance} />
                      <Route path={["/hr/leaves"]} component={Leaves} />
                      <Route
                        path={["/leave-actions"]}
                        component={LeaveActions}
                      />
                      <Route path={["/apply-leave"]} component={ApplyLeave} />
                      <Route
                        path={["/lead/resource-management"]}
                        component={ResourceManagement}
                      />
                      {/* <Route path={['/master-data']} component={MasterData} /> */}
                      {/* <Route path={['/lead/quality-assurance']} component={QA} /> */}
                      {/* new quality assurance page work ois on this componenet */}
                      <Route
                        path={["/lead/quality-assurance"]}
                        component={QualityAssurance}
                      />
                      <Route
                        path={["/lead/call-data/master-database"]}
                        render={(props) => (
                          <MasterDatabase socket={sock} {...props} />
                        )}
                      />
                      <Route
                        path={["/lead/call-data/master-database-debug"]}
                        render={(props) => (
                          <ActiveDebug socket={sock} {...props} />
                        )}
                      />
                      {/* // component={MasterDatabase} */}
                      <Route
                        path={["/lead/call-data/allocations"]}
                        render={(props) => (
                          <Allocations socket={sock} {...props} />
                        )}
                      />
                      <Route
                        path={["/lead/call-data/reports"]}
                        component={Reports}
                      />
                      <Route
                        path={["/lead/call-data/analytics"]}
                        component={Analytics}
                      />
                      <Route
                        path={["/lead/call-data/reports-debug"]}
                        component={ConnectedDebug}
                      />
                      <Route
                        path={["/lead/call-data/upload"]}
                        component={Uploads}
                      />

                      {/* Page to display the details of a case using mother id */}
                      <Route
                        path={["/lead/call-data/case-details/:motherID"]}
                        component={CaseDetailsMotherId}
                      />
                      {/* End page to display the details of a case using mother id */}

                      {/* Page to display the calls table */}
                      <Route
                        path={["/lead/call-data/calls"]}
                        component={CallsIndex}
                      />
                      {/* End Page to display the calls table */}
                      <Route
                        path={["/telecaller/caller-dashboard"]}
                        component={Caller}
                      />
                      <Route
                        path={["/lead/campaigns"]}
                        component={CampaignsComponent}
                      />
                      <Route path={["/logs/cases"]} component={Logs} />

                      <Route path={"/"} exact component={HomeDashboard} />
                      <Route
                        path={"*"}
                        component={() => {
                          return (
                            <>
                              <h1>404 Page not found</h1>
                            </>
                          );
                        }}
                      />
                    </Switch>
                  </Stack>
                </Box>
              </Main>
            </Box>
          </Box>
        </LocalizationProvider>
      )}
    </>
  );
};
